/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../components/InlineEdit";
import { Button } from "../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../utils/customHooks";
import { SpinnerOverlay } from "../utils/SpinnerOverlay";

const Wzor25: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Wielkie przygody");
  const [text2, setText2] = useState<string>("małego Juliana");
  const [fontSizeText1, setFontSizeText1] = useState<number>(54);
  const [fontSizeText2, setFontSizeText2] = useState<number>(70);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "190mm"; // PDF width in mm
  const pdfHeight = "250mm"; // PDF height in mm
  const maxWidth = 550; // Maximum width for text
  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'Caveatbrush'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'Caveatbrush'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'Caveatbrush'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, 54, 10));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, 70, 10));
  }, [text2]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth, // PDF width in mm
        pdfHeight: pdfHeight, // PDF height in mm
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null, // No image provided
      false // Disable the image requirement
    );
  };

  return (
    <div className={'wrapper'}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />

      <div style={{ position: "absolute", top: "20px", left: "20px" }}>
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        className="bg-white wzor-25"
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "Caveatbrush",
        }}
      >
        <div className="wzor-25-header-wrapper">
          <InlineEdit
            value={text1}
            setValue={setText1}
            classes="wzor-25-header wzor-25-header-1"
            style={{
              fontSize: `${fontSizeText1}px`,
              width: `${maxWidth}px`,
              height: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
          <InlineEdit
            value={text2}
            setValue={setText2}
            classes="wzor-25-header wzor-25-header-2"
            style={{
              fontSize: `${fontSizeText2}px`,
              width: `${maxWidth}px`,
              height: "76px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </div>

        <img
          className="wzor-25-bg"
          src="/images/WZ25.svg"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
};

export default Wzor25;
